<template>
    <div>

        <form class="page-form form-horizontal" @submit.prevent="submit()">

            <div class="form-group">
                <label for="pages_id" class="col-sm-2 control-label">IDs de Fichas</label>
                <div class="col-sm-10">
                  <div :class="{'has-error': errors['pages_id']}">
                    <textarea rows="5" :disabled="updateForm.added" @change.prevent="listPagesIds()" class="form-control textarea-limits" v-model="updateForm.pages_id"></textarea>
                    <div class="help-block" v-for="e in errors['pages_id']">El campo ID de fichas es obligatorio</div>
                  </div>
                  <div class="help-block">Deben ser separados por coma. Ej: 1234,1235,1236</div>
                </div>
            </div>

            <div class="form-group">
                <label for="pages_id" class="col-sm-2 control-label">IDs Agregados</label>
                <div class="col-sm-10">
                    <div class="tableFixHead table-responsive">
                        <table class="table table-striped table-condensed">
                            <thead>
                                <tr>
                                    <th>Id de la Ficha</th>
                                    <th>Verificación</th>
                                    <th>Título</th>
                                    <th>Estado de la Ficha</th>
                                    <th>Ir a la Ficha</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="page,i in listedPagesValidated" :key="i" :class="checkPageStatus(page.status)">
                                    <td>{{ page.page_id }}</td>
                                    <td><span>{{ page.status }}</span></td>
                                    <td>
                                        <span class="text-primary" v-if="page.status == 'Válida'">{{ page.pageTitle | cutLongText(40, '...') }}</span>
                                        <span v-else>No disponible</span>
                                    </td>
                                    <td>
                                        <span v-if="page.status == 'Válida'">{{ page.pageStatus || 'Sin estado' }}</span>
                                        <span v-else>Sin estado</span>
                                    </td>
                                    <td>
                                        <a v-if="page.status == 'Válida'" :href="`backend/fichas/${page.page_id}`" target="_blank">
                                            Ir a la Ficha
                                            <i class="material-icons">reply</i>
                                        </a>
                                        <span v-else>{{ page.status }}</span>
                                    </td>
                                    <td>
                                        <button class="btn btn-danger btn-xs" @click.prevent="unstagePageFromList(page)">
                                            <i class="material-icons">delete_forever</i>
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="listedPagesValidated.length == 0">
                                    <td colspan="7">No se han agregado ids de fichas</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="help-block">Tabla de pre visualización de los IDs a modificar</div>
                    <button v-if="listedPagesValidated.filter(page => page.status == 'Ficha no disponible').length > 0" type="button" class="btn btn-danger" @click.prevent="cleanInexistPageFromForm()">
                        Eliminar Fichas No Disponibles
                        <span>({{listedPagesValidated.filter(page => page.status == 'Ficha no disponible').length}})</span>
                    </button>
                </div>

            </div>

            <div class="form-group">
                <label for="newDate" class="col-sm-2 control-label">Nueva fecha de publicación</label>
                <div class="col-sm-10">
                    <div :class="{'has-error': errors['newDate']}">
                      <el-date-picker id="newDate" v-model="updateForm.newDate" type="date" value-format="dd-MM-yyyy" format="dd-MM-yyyy" :picker-options="{firstDayOfWeek: 1}" placeholder="Seleccione una fecha"></el-date-picker>
                      <div class="help-block" v-for="e in errors['newDate']">El campo nueva fecha es obligatorio</div>
                    </div>
                    <div class="help-block">Indique la nueva Fecha de Publicación</div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <button type="button" class="btn btn-default" @click.prevent="cleanUpdateForm()">Cancelar</button>
                    <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
            </div>

        </form>

    </div>
</template>
<style scoped>

    .textarea-limits {
        max-width:100%;
        min-width:100%;
        max-height:150px;
    }

    .tableFixHead          { overflow-y: auto; max-height: 300px; }
    .tableFixHead thead th { position: sticky; top: 0; }

    table  { border-collapse: collapse; width: 100%; border-radius: 3px; }
    th, td { padding: 8px 16px; }
    th     { background:#eee; }

</style>
<script>

import ElDatePicker from 'element-ui/lib/date-picker'

export default {
    name: 'page-bulk-update-dates-form',
    data: function(){
        return{
            updateForm: {
                pages_id: null,
                newDate: null,
            },
            listedPagesIds: [],
            listedPagesValidated: [],
            errors: {}
        }
    },
    components:{
        ElDatePicker
    },
    filters: {
        cutLongText: function (text, length, clamp) {
            clamp = clamp || '...';
            var node = document.createElement('div');
            node.innerHTML = text;
            var content = node.textContent;
            return content.length > length ? content.slice(0, length) + clamp : content;
        },
    },
    methods:{
        cleanInexistPageFromForm: function () {
            for (let i in this.listedPagesValidated) {
                if (this.listedPagesValidated[i].status === 'Ficha no disponible' || !this.listedPagesValidated[i].status === 'Válida') {
                    this.unstagePageFromList(this.listedPagesValidated[i])
                }
            }
        },
        cleanUpdateForm: function () {
            this.updateForm = {
                pages_id: null,
                newDate: null,
            }
            this.listedPagesIds = []
            this.listedPagesValidated = []
        },
        checkIfExistPage: function (page_id) {
            return this.makeCheckRequest(page_id).then(response => response)
        },
        checkPageStatus: function (status) {
            return status == 'Válida' ? 'text-success' : status == 'En validación' ? 'text-warning' : 'text-danger'
        },
        listPagesIds: function () {

            let validation = this.updateForm.pages_id.toString().match(/^(([0-9](,)?)*)+$/)

            if (!validation) {
                return alert('Se encontraron errores en el ingreso de los Ids de fichas')
            }

            let pages_id = this.updateForm.pages_id.split(',')
            for (let i in pages_id) {
                if (pages_id[i] && pages_id[i].trim() != '') {
                    if (this.listedPagesIds.indexOf(pages_id[i]) === -1) {
                        this.listedPagesIds.push(pages_id[i])
                        this.listedPagesValidated.push({
                            page_id: pages_id[i],
                            status: 'En validación',
                            pageTitle: 'En validación',
                            pageStatus: 'En validación',
                        })
                    }
                }
            }

            this.updateForm.pages_id = null

            for (let i in this.listedPagesValidated) {
                if (this.listedPagesValidated[i].status == 'En validación' ) {
                    this.checkIfExistPage(this.listedPagesValidated[i].page_id).then(response => {
                        this.listedPagesValidated[i].status = response.status
                        this.listedPagesValidated[i].pageTitle = response.page.title
                        this.listedPagesValidated[i].pageStatus = response.page.status
                    })
                }
            }

        },
        makeCheckRequest: async function (page_id) {
            return await axios({
                url: `backend/fichas/dateupdate/checkIfExistPage`,
                method: 'POST',
                data: {page_id:page_id}
            }).then(function(response){
                if (response.data.page) {
                    return {page:response.data.page, status:'Válida'}
                }
                return {status:'Ficha no disponible'}
            }).catch(function(error){
                console.error(error)
            })
        },
        submit: function(){

            this.updateForm.pages_id = this.listedPagesIds
            let self = this
            axios({
                url: 'backend/fichas/dateupdate',
                method: 'POST',
                data: this.updateForm,
            }).then(function(response){
                window.location.replace(response.data.redirect)
            }).catch(function(error){
                self.errors = error.response.data.errors
            })
        },
        unstagePageFromList: function (page) {
            this.listedPagesIds.splice(this.listedPagesIds.indexOf(page.page_id), 1)
            this.listedPagesValidated.splice(this.listedPagesValidated.indexOf(page), 1)
        },
    }
}
</script>
